import { getIn } from '@aytm/app/stats/lib/util/helpers'

const collator = new Intl.Collator(undefined, { numeric: false, sensitivity: 'base' })

export const sortData = (answer = {}, answerVariants, sortOrder = 'iasc', options = {}) => {
  const { ignoreAmount, ignorePercents } = options

  let hasBase = Object.hasOwn(answer, 'base')
  hasBase = hasBase || Object.keys(answer).some(key => answer[key] != null && Object.hasOwn(answer[key], 'base'))

  const answerPath = options.answerPath || 'a'
  const answerType = options.answerType || 'amount'

  const variants = answerVariants.filter(av => av != null)
  variants.sort((a, b) => {
    const aPosition = Number(a.position)
    const bPosition = Number(b.position)

    if (sortOrder.split('-').length === 1) {
      let aValue = Number((!ignorePercents && answer[`${answerPath}${aPosition}`]?.percents) || 0)
      let bValue = Number((!ignorePercents && answer[`${answerPath}${bPosition}`]?.percents) || 0)

      if (!(hasBase || ignoreAmount) && aValue === bValue) {
        aValue = String(answer[`${answerPath}${aPosition}`]?.[answerType] || 0)
        bValue = String(answer[`${answerPath}${bPosition}`]?.[answerType] || 0)
      }

      const valueIsNumeric = !Number.isNaN(Number(aValue)) && !Number.isNaN(Number(bValue))

      let abValue, baValue
      if (valueIsNumeric) {
        abValue = Number(aValue)
        baValue = Number(bValue)
      } else {
        abValue = collator.compare(aValue, bValue)
        baValue = collator.compare(bValue, aValue)
      }

      switch (sortOrder) {
        case 'vasc':
          return abValue + aPosition / 100000 - (baValue + bPosition / 100000)
        case 'vdesc':
          return baValue + bPosition / 100000 - (abValue + aPosition / 100000)
        case 'iasc':
          return aPosition - bPosition
        case 'idesc':
          return bPosition - aPosition
      }
    } else {
      const paramName = sortOrder.split('-')[0]
      const paramSortOrder = sortOrder.split('-')[1]

      const paramPath = options.paramPath?.[paramName] || paramName

      const aParamValue = String(
        (paramPath
          ? getIn(paramPath, answer[`${answerPath}${aPosition}`])
          : answer[`${answerPath}${aPosition}`]?.[paramName]) || 0
      )
      const bParamValue = String(
        (paramPath
          ? getIn(paramPath, answer[`${answerPath}${bPosition}`])
          : answer[`${answerPath}${bPosition}`]?.[paramName]) || 0
      )
      const valueIsNumeric = !Number.isNaN(Number(aParamValue)) && !Number.isNaN(Number(bParamValue))

      let abParamValue, baParamValue
      if (valueIsNumeric) {
        abParamValue = Number(aParamValue)
        baParamValue = Number(bParamValue)
      } else {
        abParamValue = collator.compare(aParamValue, bParamValue)
        baParamValue = collator.compare(bParamValue, aParamValue)
      }

      switch (paramSortOrder) {
        case 'asc':
          return abParamValue + aPosition / 100000 - (baParamValue + bPosition / 100000)
        case 'desc':
          return baParamValue + bPosition / 100000 - (abParamValue + aPosition / 100000)
      }
    }

    return 0 // unknown sort order — keep original relative order
  })

  return variants
}
